import { connect } from 'react-redux';
import { appModalOpen } from 'actions';

import View from './';

const mapStateToProps = state => ({ intl: state.intl });
const mapDispatchToProps = dispatch => ({
  appModalOpen(payload) {
    dispatch(appModalOpen(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/components/more-info/container.js